import React from "react";
import { Helmet } from "react-helmet";

export default function MetaHome() {
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": "https://frwebdesign.net/#website",
      url: "https://frwebdesign.net/",
      name: "FR Webdesign",
      publisher: { "@id": "https://frwebdesign.net/#localbusiness" },
      potentialAction: {
        "@type": "SearchAction",
        target: "https://frwebdesign.net/search?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://frwebdesign.net/#localbusiness",
      name: "FR Webdesign",
      legalName: "Frantz Rouzé - FR Webdesign",
      image: "https://frwebdesign.net/LOGO-FR-WEBDESIGN.svg",
      telephone: "+33682030266",
      url: "https://frwebdesign.net/",
      sameAs: [
        "https://www.linkedin.com/in/frantz-rouz%C3%A9/",
        "https://www.youtube.com/@frwebdesign59/",
        "https://www.facebook.com/FRWebdesign.by.frantz.rouze",
        "https://www.instagram.com/frantz_fr_webdesign/",
        "https://www.google.com/maps?cid=TON_ID_CID_SI_DISPONIBLE",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "103, rue Victor Hugo",
        addressLocality: "Leers",
        postalCode: "59115",
        addressCountry: "FR",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: "50.68336553937294",
        longitude: "3.2519920398914324",
      },
      areaServed: {
        "@type": "GeoCircle",
        geoMidpoint: {
          "@type": "GeoCoordinates",
          latitude: "50.68336553937294",
          longitude: "3.2519920398914324",
        },
        geoRadius: "50000",
      },
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Services SEO et Web",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "SEO Local & SEO GEO (IA)",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Création de site web professionnel",
            },
          },
        ],
      },
      openingHours: "Mo-Fr 09:00-18:00",
      priceRange: "€€",
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Accueil",
          item: "https://frwebdesign.net/",
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Y a-t-il un engagement sur vos abonnements ?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Non. Les abonnements démarrent à 49 €/mois. Le pack site + SEO local démarre à 79 €/mois. Résiliation possible à tout moment.",
          },
        },
        {
          "@type": "Question",
          name: "Intervenez-vous seulement localement ou partout ?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "J'accompagne les indépendants, TPE et PME partout en France et en Belgique, avec une forte expertise en SEO local.",
          },
        },
        {
          "@type": "Question",
          name: "En combien de temps un site vitrine peut-il être en ligne ?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "En général entre 2 et 4 semaines, selon la formule choisie et la remise des contenus.",
          },
        },
      ],
    },
  ];

  return (
    <Helmet>
      <link rel="alternate" type="text/markdown" href="https://frwebdesign.net/index.md" />
      <title>
        Consultant SEO/GEO & Création de site web | Expert en visibilité
        digitale (IA incluse) | FR Webdesign (Frantz Rouzé)
      </title>
      <meta
        name="description"
        content="Invisible sur Google, Maps ou l'IA ? En tant que consultant SEO/GEO & création de site web, je rends votre activité visible là où vos clients vous cherchent."
      />
      <link rel="canonical" href="https://frwebdesign.net/" />

      {/* Open Graph */}
      <meta
        property="og:title"
        content="Consultant SEO/GEO & Création de site web | FR Webdesign"
      />
      <meta
        property="og:description"
        content="Invisible sur Google, Maps ou l'IA ? Expert en visibilité digitale à Leers, Lille et Belgique."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://frwebdesign.net/" />
      <meta
        property="og:image"
        content="https://frwebdesign.net/images-site-web/meta/home.jpg"
      />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
